import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "icon": "contacts-cbf4f629-icon-D9SRnq",
  "quote": "contacts-cbf4f629-quote-D9SRnq"
};